import { Box, Button, FormControl, FormLabel, HStack, Input, Modal, ModalBody, ModalContent, ModalOverlay, } from '@chakra-ui/react';
import React, { useState } from 'react';
import { localise, templateReplace } from '../../../services/lang/lang';
import { useTokens } from '../../../context/TokenProvider';
import { RenderIf } from '../RenderIf/RenderIf';
import { ErrorAwareAlertBox } from '../ErrorAwareAlertBox/ErrorAwareAlertBox';
import StandardModalHeader from '../Modal/StandardModalHeader';
export const ConfirmationModal = (props) => {
    const tokens = useTokens();
    const [confirmInput, setConfirmInput] = useState('');
    const onSubmit = (e) => {
        e.preventDefault();
        props.onConfirm();
    };
    const isConfirmDisabled = !!props.confirmText && confirmInput !== props.confirmText;
    return (React.createElement(Modal, { "data-testid": "confirm-modal", variant: "primary", isOpen: props.isOpen, onClose: props.onClose, trapFocus: true },
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, null,
            React.createElement(StandardModalHeader, { title: props.title, closeButtonTestId: "confirmation-modal__close-icon" }),
            React.createElement(RenderIf, { condition: props.isError === true },
                React.createElement(ErrorAwareAlertBox, { error: props.error })),
            React.createElement(ModalBody, null,
                React.createElement(Box, { paddingY: tokens.Spacing06 }, props.children),
                React.createElement("form", { onSubmit: onSubmit },
                    React.createElement(RenderIf, { condition: !!props.confirmText },
                        React.createElement(FormControl, { py: tokens.Spacing04 },
                            React.createElement(FormLabel, { htmlFor: "delete-confirmation" }, templateReplace(localise('DELETE_CONFIRMATION'), {
                                challenge: props.confirmText,
                            })),
                            React.createElement(Input, { "data-testid": "confirm_modal__delete_confirmation", onChange: (e) => setConfirmInput(e.target.value), value: confirmInput, id: "delete-confirmation", variant: "primary" }))),
                    React.createElement(HStack, { mt: 4, width: "100%", justifyContent: "end", gap: tokens.Spacing06 },
                        React.createElement(Button, { variant: "secondary", onClick: props.onClose, "data-testid": "confirmation-modal__close" }, localise('CANCEL')),
                        React.createElement(Button, { variant: "primary", type: "submit", isDisabled: isConfirmDisabled, "data-testid": "confirmation-modal__confirm", isLoading: props.isLoading }, localise('CONFIRM'))))))));
};
